import React, { useState } from 'react';
import { Typography, Button } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  IdcardOutlined,
  MedicineBoxOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import './PatientProfileCard.scss';

const { Text } = Typography;

function formatPhone(patient) {
  if (patient?.notificationPhone?.number) {
    const { countryCode, regionCode, number } = patient.notificationPhone;
    return [countryCode, regionCode, number].filter(Boolean).join(' ');
  }
  return patient?.phone || null;
}

function ProfileField({ icon, label, value }) {
  if (!value || value === '-') return null;

  return (
    <div className="profile-field">
      <span className="profile-field__label">
        {icon}
        {label}
      </span>
      <Text className="profile-field__value">{value}</Text>
    </div>
  );
}

export default function PatientProfileCard({ patient }) {
  const [expanded, setExpanded] = useState(false);
  const age = patient?.birthDate
    ? dayjs().diff(patient.birthDate, 'year')
    : null;

  const hasDetails =
    patient.socialWork ||
    patient.affiliate ||
    patient.birthDate ||
    patient.sex ||
    patient.city ||
    formatPhone(patient) ||
    patient.email;

  return (
    <div className="patient-profile-card">
      <div
        className={`patient-profile-card__header${
          expanded ? ' patient-profile-card__header--expanded' : ''
        }`}
      >
        <div className="patient-profile-card__summary">
          <UserOutlined className="patient-profile-card__icon" />
          <div className="patient-profile-card__identity">
            <Text strong className="patient-profile-card__name">
              {patient.name}
            </Text>
            <Text type="secondary" className="patient-profile-card__dni">
              DNI: {patient.dni}
              {age !== null && ` · ${age} años`}
            </Text>
          </div>
        </div>

        {hasDetails && (
          <Button
            type="link"
            className="patient-profile-card__toggle"
            onClick={() => setExpanded(!expanded)}
            icon={expanded ? <UpOutlined /> : <DownOutlined />}
          >
            {expanded ? 'Ver menos' : 'Ver más'}
          </Button>
        )}
      </div>

      {expanded && hasDetails && (
        <div className="patient-profile-card__grid">
          <ProfileField
            icon={<MedicineBoxOutlined />}
            label="Obra social"
            value={patient.socialWork}
          />
          <ProfileField
            icon={<IdcardOutlined />}
            label="Afiliado"
            value={patient.affiliate}
          />
          <ProfileField
            icon={<CalendarOutlined />}
            label="Fecha de nacimiento"
            value={
              patient.birthDate
                ? dayjs(patient.birthDate).format('DD/MM/YYYY')
                : null
            }
          />
          <ProfileField
            icon={<UserOutlined />}
            label="Sexo"
            value={patient.sex}
          />
          <ProfileField
            icon={<EnvironmentOutlined />}
            label="Ciudad"
            value={patient.city}
          />
          <ProfileField
            icon={<PhoneOutlined />}
            label="Teléfono"
            value={formatPhone(patient)}
          />
          <ProfileField
            icon={<MailOutlined />}
            label="Email"
            value={patient.email}
          />
        </div>
      )}
    </div>
  );
}
